var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSquareLogoBroker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 10,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.744 32.542c-1.116 0-2.065-.614-2.568-1.563l-5.861-11.723c-.726-1.396-.112-3.127 1.284-3.852 1.395-.726 3.126-.112 3.852 1.284l3.517 7.034c3.182-5.08 8.876-13.063 15.184-17.53 1.284-.893 3.07-.613 3.963.67.893 1.285.614 3.07-.67 3.964-8.54 6.03-16.133 20.041-16.189 20.209a2.805 2.805 0 01-2.512 1.507z",
    fill: "#00AEEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.75 20.205c-1.284 0-2.344 1.005-2.344 2.288v9.1a2.74 2.74 0 01-2.736 2.735H16.207a2.74 2.74 0 01-2.735-2.735V16.185a2.74 2.74 0 012.735-2.735h11.946a2.359 2.359 0 002.345-2.345 2.359 2.359 0 00-2.345-2.344H14.756c-3.294 0-6.03 2.68-6.03 6.029v18.366c0 3.294 2.68 6.029 6.03 6.029h18.31c3.294 0 6.029-2.68 6.029-6.03v-10.55c0-1.34-1.06-2.4-2.345-2.4z",
    fill: "#003A80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareLogoBroker);
export default __webpack_public_path__ + "static/media/squareLogoBroker.4e7f2a854bc1a594a78fd30c648b113c.svg";
export { ForwardRef as ReactComponent };